export const environment = {
    production: false,
    apiBaseUrl: 'https://app.development-us-east-1.workgraph.co',
    gatewayBaseUrl: 'https://api.development-us-east-1.workgraph.co',

    // Cognito configuration for deployed development environment
    cognito: {
        userPoolId: 'us-east-1_X9ogLoqJP',
        clientId: '6gse82oeotja4fv7ebi45n3g2c',
        domain: 'auth.development-us-east-1.workgraph.co',
        redirectUri: 'https://app.development-us-east-1.workgraph.co/auth/callback',
        logoutUri: 'https://app.development-us-east-1.workgraph.co',
        scopes: ['email', 'openid', 'profile'],
        responseType: 'code',
    },
};
